<template>
  <div class="relative flex h-auto min-h-screen w-full flex-col bg-background-light dark:bg-background-dark group/design-root overflow-x-hidden text-[#0d121b] dark:text-white">
    <div class="w-full bg-white dark:bg-[#1a202c] border-b border-[#e7ebf3] dark:border-[#2d3748]">
      <AppHeader />
    </div>
    <div class="w-full bg-white dark:bg-[#1a202c]">
      <div class="layout-container flex flex-col mx-auto max-w-[1280px]">
        <div class="px-4 py-6 lg:px-10 lg:py-8">
          <div class="bg-cover bg-center flex flex-col justify-end overflow-hidden rounded-xl min-h-[200px] lg:min-h-[280px] relative" data-alt="Modern construction worker skyline silhouette banner" style='background-image: linear-gradient(0deg, rgba(19, 91, 236, 0.8) 0%, rgba(19, 91, 236, 0.4) 100%), url("https://lh3.googleusercontent.com/aida-public/AB6AXuDCJWUF_g8Gs6Py1H7uv6qneivkLg3kKo9PAYb_kuHXfFWbqnKbgBizv4zeRtF6MZbgkipcca5pS7GWS8Jr-qMNoaRGX0x6F0ZEHFlvHJMM40QH71wPxeaJKaVKrHYF2kNT_sJC_a0dRlnCEboQKdbt16RvKWUGqUn7UAW9Xcp9kLy3IVP3-h8y_Bj53t3a3-lJKYE5VU2MoTXNp9W6fNQPkCbckLHvosbLFTLLcdadWdoIWxYsgx0W1zdQ5lbFQrHIhcptA-Oq160");'>
            <div class="absolute inset-0 bg-black/20"></div>
            <div class="flex flex-col p-6 lg:p-10 relative z-10">
              <h1 class="text-white tracking-tight text-3xl lg:text-4xl font-bold leading-tight mb-2">联系我们</h1>
              <p class="text-white/90 text-base lg:text-lg font-medium">如有任何疑问或建议，请随时与我们联系，我们将竭诚为您服务。</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="layout-container flex flex-col mx-auto max-w-[1280px] flex-1 pb-12">
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 px-4 lg:px-10 py-8">
        <div class="flex flex-col gap-8 h-full">
          <div class="flex flex-col gap-4">
            <div class="flex flex-col gap-2 mb-2">
              <h2 class="text-[#0d121b] dark:text-white text-2xl font-bold leading-tight">联系方式</h2>
              <p class="text-[#4c669a] dark:text-gray-400 text-sm font-normal">湖北省建筑劳务协会官方联系渠道</p>
            </div>
            <div class="flex items-start gap-4 rounded-xl border border-[#e7ebf3] dark:border-[#2d3748] bg-white dark:bg-[#1a202c] p-5 shadow-sm hover:shadow-md transition-shadow">
              <div class="flex items-center justify-center size-12 rounded-full bg-primary/10 text-primary shrink-0">
                <span class="material-symbols-outlined">location_on</span>
              </div>
              <div class="flex flex-col gap-1">
                <h3 class="text-[#0d121b] dark:text-white text-base font-bold">办公地址</h3>
                <p class="text-[#4c669a] dark:text-gray-400 text-sm leading-relaxed">武汉市汉阳区龙阳大道123号<br/>欧亚达汉阳国际广场A座1803</p>
                <p class="text-[#4c669a] dark:text-gray-400 text-xs mt-1">邮编：430000</p>
              </div>
            </div>
            <div class="flex items-start gap-4 rounded-xl border border-[#e7ebf3] dark:border-[#2d3748] bg-white dark:bg-[#1a202c] p-5 shadow-sm hover:shadow-md transition-shadow">
              <div class="flex items-center justify-center size-12 rounded-full bg-primary/10 text-primary shrink-0">
                <span class="material-symbols-outlined">call</span>
              </div>
              <div class="flex flex-col gap-1">
                <h3 class="text-[#0d121b] dark:text-white text-base font-bold">联系电话/传真</h3>
                <p class="text-[#4c669a] dark:text-gray-400 text-sm">027-84881278</p>
                <p class="text-[#4c669a] dark:text-gray-400 text-xs mt-1">工作日 08:30 - 17:30</p>
              </div>
            </div>
            <div class="flex items-start gap-4 rounded-xl border border-[#e7ebf3] dark:border-[#2d3748] bg-white dark:bg-[#1a202c] p-5 shadow-sm hover:shadow-md transition-shadow">
              <div class="flex items-center justify-center size-12 rounded-full bg-primary/10 text-primary shrink-0">
                <span class="material-symbols-outlined">mail</span>
              </div>
              <div class="flex flex-col gap-1">
                <h3 class="text-[#0d121b] dark:text-white text-base font-bold">电子邮箱</h3>
                <p class="text-[#4c669a] dark:text-gray-400 text-sm break-all">hbsjzlwxh@163.com</p>
              </div>
            </div>
          </div>
          <div class="rounded-xl overflow-hidden border border-[#e7ebf3] dark:border-[#2d3748] flex-1 min-h-[400px] relative w-full bg-gray-100 dark:bg-[#2d3748] shadow-sm z-0">
             <div id="map" class="w-full h-full z-10"></div>
          </div>
        </div>
        <div class="flex flex-col h-full">
          <div class="bg-white dark:bg-[#1a202c] rounded-xl border border-[#e7ebf3] dark:border-[#2d3748] p-6 lg:p-10 shadow-sm h-full">
            <div class="mb-8">
              <h2 class="text-[#0d121b] dark:text-white text-2xl font-bold leading-tight mb-2">在线留言</h2>
              <p class="text-[#4c669a] dark:text-gray-400 text-base">请填写以下表单，我们的工作人员会在收到后尽快与您联系。</p>
            </div>
            <form class="flex flex-col gap-6" @submit.prevent="handleSubmit">
              <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                <label class="flex flex-col gap-2">
                  <span class="text-[#0d121b] dark:text-gray-200 text-sm font-medium">您的姓名 <span class="text-red-500">*</span></span>
                  <input v-model="form.name" class="w-full h-12 rounded-lg border border-[#cfd7e7] dark:border-[#4a5568] bg-[#f8f9fc] dark:bg-[#2d3748] px-4 text-[#0d121b] dark:text-white placeholder:text-[#9aa6c0] focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-all" placeholder="请输入您的姓名" type="text" required/>
                </label>
                <label class="flex flex-col gap-2">
                  <span class="text-[#0d121b] dark:text-gray-200 text-sm font-medium">联系电话 <span class="text-red-500">*</span></span>
                  <input v-model="form.phone" class="w-full h-12 rounded-lg border border-[#cfd7e7] dark:border-[#4a5568] bg-[#f8f9fc] dark:bg-[#2d3748] px-4 text-[#0d121b] dark:text-white placeholder:text-[#9aa6c0] focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-all" placeholder="请输入手机号码" type="tel" required/>
                </label>
              </div>
              <label class="flex flex-col gap-2">
                <span class="text-[#0d121b] dark:text-gray-200 text-sm font-medium">电子邮箱</span>
                <input v-model="form.email" class="w-full h-12 rounded-lg border border-[#cfd7e7] dark:border-[#4a5568] bg-[#f8f9fc] dark:bg-[#2d3748] px-4 text-[#0d121b] dark:text-white placeholder:text-[#9aa6c0] focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-all" placeholder="example@email.com" type="email"/>
              </label>
              <label class="flex flex-col gap-2">
                <span class="text-[#0d121b] dark:text-gray-200 text-sm font-medium">咨询主题</span>
                <div class="relative">
                  <select v-model="form.subject" class="w-full h-12 appearance-none rounded-lg border border-[#cfd7e7] dark:border-[#4a5568] bg-[#f8f9fc] dark:bg-[#2d3748] px-4 text-[#0d121b] dark:text-white focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-all pr-10">
                    <option disabled="" value="">请选择咨询类型</option>
                    <option value="会员服务">会员服务</option>
                    <option value="维权咨询">维权咨询</option>
                    <option value="业务合作">业务合作</option>
                    <option value="其他建议">其他建议</option>
                  </select>
                  <div class="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none text-[#4c669a]">
                    <span class="material-symbols-outlined">expand_more</span>
                  </div>
                </div>
              </label>
              <label class="flex flex-col gap-2">
                <span class="text-[#0d121b] dark:text-gray-200 text-sm font-medium">留言内容 <span class="text-red-500">*</span></span>
                <textarea v-model="form.content" class="w-full min-h-[160px] resize-y rounded-lg border border-[#cfd7e7] dark:border-[#4a5568] bg-[#f8f9fc] dark:bg-[#2d3748] p-4 text-[#0d121b] dark:text-white placeholder:text-[#9aa6c0] focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-all" placeholder="请详细描述您的问题或建议..." required></textarea>
              </label>
              <div class="flex items-center gap-2 mt-2">
                <input v-model="agreePrivacy" class="rounded border-gray-300 text-primary focus:ring-primary" id="privacy" type="checkbox"/>
                <label class="text-sm text-[#4c669a] dark:text-gray-400" for="privacy">我已阅读并同意 <a class="text-primary hover:underline" href="#">隐私政策</a></label>
              </div>
              <button :disabled="submitting" class="mt-4 flex w-full md:w-auto md:self-start items-center justify-center gap-2 rounded-lg bg-primary px-8 py-3 text-base font-bold text-white shadow-md hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 transition-all disabled:opacity-50 disabled:cursor-not-allowed" type="submit">
                <span>{{ submitting ? '正在提交...' : '提交留言' }}</span>
                <span v-if="!submitting" class="material-symbols-outlined text-[20px]">send</span>
                <el-icon v-else class="is-loading"><Loading /></el-icon>
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
    <footer class="border-t border-[#e7ebf3] dark:border-[#2d3748] bg-white dark:bg-[#1a202c]">
      <div class="layout-container flex flex-col mx-auto max-w-[1280px] px-4 py-10 lg:px-10">
        <div class="flex flex-col md:flex-row justify-between gap-10">
          <div class="flex flex-col gap-4 max-w-sm">
            <div class="flex items-center gap-2 text-[#0d121b] dark:text-white">
              <img alt="Logo" class="size-8 object-contain" src="/logo.png"/>
              <h3 class="text-lg font-bold">湖北省建筑劳务协会</h3>
            </div>
            <p class="text-[#4c669a] dark:text-gray-400 text-sm leading-relaxed">
              弘扬工匠精神，助推行业发展!<br/>
              ——为建筑劳务保驾护航!
            </p>
            <div class="flex flex-col gap-2 mt-2">
               <span class="text-xs text-gray-400">关注我们</span>
               <img src="/images/wechat_qrcode.jpg" class="w-24 h-24 border border-gray-200 p-1 rounded bg-white shadow-sm" alt="公众号二维码">
            </div>
          </div>
          <div class="grid grid-cols-2 md:grid-cols-3 gap-8 md:gap-16">
            <div class="flex flex-col gap-3">
              <h4 class="text-[#0d121b] dark:text-white font-bold">关于我们</h4>
              <a class="text-[#4c669a] dark:text-gray-400 text-sm hover:text-primary transition-colors" href="#">组织简介</a>
              <a class="text-[#4c669a] dark:text-gray-400 text-sm hover:text-primary transition-colors" href="#">领导机构</a>
              <a class="text-[#4c669a] dark:text-gray-400 text-sm hover:text-primary transition-colors" href="#">大事记</a>
            </div>
            <div class="flex flex-col gap-3">
              <h4 class="text-[#0d121b] dark:text-white font-bold">服务中心</h4>
              <a class="text-[#4c669a] dark:text-gray-400 text-sm hover:text-primary transition-colors" href="#">法律援助</a>
              <a class="text-[#4c669a] dark:text-gray-400 text-sm hover:text-primary transition-colors" href="#">互助保障</a>
              <a class="text-[#4c669a] dark:text-gray-400 text-sm hover:text-primary transition-colors" href="#">技能培训</a>
            </div>
            <div class="flex flex-col gap-3 col-span-2 md:col-span-1">
              <h4 class="text-[#0d121b] dark:text-white font-bold">联系信息</h4>
              <p class="text-[#4c669a] dark:text-gray-400 text-sm">武汉市汉阳区龙阳大道123号<br/>欧亚达汉阳国际广场A座1803</p>
              <p class="text-[#4c669a] dark:text-gray-400 text-sm">电话/传真: 027-84881278</p>
              <p class="text-[#4c669a] dark:text-gray-400 text-sm">邮箱: hbsjzlwxh@163.com</p>
            </div>
          </div>
        </div>
        <div class="mt-10 pt-6 border-t border-[#e7ebf3] dark:border-[#2d3748] flex flex-col md:flex-row justify-between items-center gap-4">
          <p class="text-[#9aa6c0] dark:text-gray-500 text-sm text-center md:text-left">©2018 湖北省建筑劳务协会保留所有权利。 | <a href="https://beian.miit.gov.cn/" target="_blank" class="hover:text-primary">鄂ICP备18023234号-1</a></p>
          <div class="flex gap-4">
            <a class="text-[#9aa6c0] dark:text-gray-500 hover:text-primary transition-colors" href="#">
              <span class="material-symbols-outlined text-[20px]">public</span>
            </a>
            <a class="text-[#9aa6c0] dark:text-gray-500 hover:text-primary transition-colors" href="#">
              <span class="material-symbols-outlined text-[20px]">chat</span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue';
import request from '@/utils/request';
import { ElMessage } from 'element-plus';
import { Loading } from '@element-plus/icons-vue';

export default {
  name: 'ContactUs',
  components: {
    AppHeader,
    Loading
  },
  data() {
    return {
      map: null,
      form: {
        name: '',
        phone: '',
        email: '',
        subject: '',
        content: ''
      },
      agreePrivacy: false,
      submitting: false
    }
  },
  mounted() {
    this.initMap();
  },
  beforeUnmount() {
    if (this.map) {
      this.map.remove();
      this.map = null;
    }
  },
  methods: {
    initMap() {
      // 检查L是否定义 (Leaflet)
      if (typeof window.L === 'undefined') {
        console.error('Leaflet is not loaded');
        return;
      }
      
      // Wuhan Coordinates
      const wuhanCoords = [30.556, 114.205]; 

      this.map = window.L.map('map').setView(wuhanCoords, 15);

      window.L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      }).addTo(this.map);

      window.L.marker(wuhanCoords).addTo(this.map)
        .bindPopup('<b>湖北省建筑劳务协会</b><br>武汉市汉阳区龙阳大道123号<br>欧亚达汉阳国际广场A座1803')
        .openPopup();
    },
    async handleSubmit() {
      if (!this.agreePrivacy) {
        ElMessage.warning('请先阅读并同意隐私政策');
        return;
      }

      if (!/^1[3-9]\d{9}$/.test(this.form.phone)) {
        ElMessage.warning('请输入有效的手机号');
        return;
      }

      this.submitting = true;
      try {
        await request.post('/contact/client/submit', this.form);
        ElMessage.success('留言提交成功！我们将尽快与您联系。');
        this.resetForm();
      } catch (error) {
        console.error('Submit error:', error);
        ElMessage.error(error.message || '提交失败，请稍后重试');
      } finally {
        this.submitting = false;
      }
    },
    resetForm() {
      this.form = {
        name: '',
        phone: '',
        email: '',
        subject: '',
        content: ''
      };
      this.agreePrivacy = false;
    },
    goToLogin() {
      this.$router.push('/login');
    }
  }
}
</script>

<style scoped>
#map {
  z-index: 10;
}
</style>
